import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { LoginCandidateService } from '../../employee/service/login-candidate/login-candidate.service';

@Injectable()
export class AuthLoginCandidateGuard implements CanActivate {
  constructor(private loginCandidateService: LoginCandidateService, private router: Router){

  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    let url: string = state.url;
    return this.checkUserLogin(route, url);
  }
  checkUserLogin(route: ActivatedRouteSnapshot, url: any): boolean {
    if (this.loginCandidateService.loggedIn()) {
      if(this.loginCandidateService.isCandidateUser){
        const userRole = this.loginCandidateService.getRole();
        if (route.data.role && route.data.role.indexOf(userRole) === -1) {
          this.router.navigate(['/login-candidate']);
          return false;
        }
        return true;
      }
    }
    this.router.navigate(['/login-candidate']);
    return false;
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/candidate/services/auth-login-candidate.guard.ts